import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useCsps } from "../../cspServices";
import { concat, equals, map, pick, pipe, prop, sortBy, toLower } from "ramda";
import { isBlank, notBlank } from "../../../util/ext";
import { useSelected } from "../OrganizeProvider";

import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import TextField from "@material-ui/core/TextField";

const sortByProjectName = sortBy(pipe(prop("projectName"), toLower));

const mapSources = pipe(
  map(pick(["projectKey", "projectName"])),
  concat([
    { projectKey: "RIP", projectName: "RIP" },
    { projectKey: "UPLOAD", projectName: "Upload" },
  ]),
  sortByProjectName,
);

const PAPER_WIDTH = 400;

const useStyles = makeStyles(theme => ({
  root: {
    width: 125,
  },

  endAdornment: {
    top: 3,
  },

  input: {
    borderRadius: 50,
    borderColor: theme.palette.primary.brandPrimary,
    "& fieldset, &fieldset:hover": {
      borderColor: `${theme.palette.primary.brandPrimary} !important`,
      borderWidth: 2,
    },
  },

  inputLabel: {
    color: theme.palette.primary.brandPrimary,
    fontWeight: "bold",
  },

  paper: {
    width: PAPER_WIDTH,
  },
}));

const CustomPopper = props => {
  return (
    <Popper {...props} style={{ width: PAPER_WIDTH }} placement="bottom-end" />
  );
};

const initialSource = {
  projectKey: "",
  projectName: "",
};

const ContentSourcesAutocomplete = ({ setSource, source }) => {
  const classes = useStyles();
  const cspResults = useCsps();
  const { removeAllSelectedContent } = useSelected();

  const [open, setOpen] = useState(false);
  const [sources, setSources] = useState([]);
  useEffect(() => {
    if (cspResults.isSuccess) {
      const sources = mapSources(cspResults.data);
      setSources(sources);
    }
  }, [cspResults.isSuccess, cspResults.data]);

  const handleChange = (_event, value, reason) => {
    setSource(equals(reason, "clear") ? initialSource : value);
    removeAllSelectedContent();
  };

  return (
    <Autocomplete
      size="small"
      id="content-origin-autocomplete"
      loading={cspResults.isLoading}
      value={source}
      options={sources}
      open={open}
      PopperComponent={CustomPopper}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disableCloseOnSelect
      classes={{
        root: classes.root,
        endAdornment: classes.endAdornment,
        inputRoot: classes.input,
        paper: classes.paper,
      }}
      onChange={handleChange}
      getOptionLabel={option => (isBlank(option) ? "" : option.projectName)}
      getOptionSelected={(opt, val) =>
        notBlank(val) && equals(opt.projectKey, val.projectKey)
      }
      renderOption={option => option.projectName}
      renderTags={() => null}
      renderInput={params => (
        <TextField
          {...params}
          InputLabelProps={{ classes: { outlined: classes.inputLabel } }}
          variant="outlined"
          label="Source"
        />
      )}
    />
  );
};

export default ContentSourcesAutocomplete;
